module.exports = __webpack_public_path__ + "static/blog08-bcf6ade008716b26b941fecb6dae7399.png";